import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type DualChannelDraftRecipientsQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type DualChannelDraftRecipientsQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    guests: {
      __typename?: 'EventGuests';
      id: string;
      people: Array<{
        __typename?: 'Person';
        id: string;
        personIdTag: string;
        firstName?: string | null;
        lastName?: string | null;
        email?: string | null;
        phoneDisplay?: string | null;
        phoneE164?: string | null;
      }>;
    };
  } | null;
};

export const DualChannelDraftRecipientsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DualChannelDraftRecipients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'guests' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'people' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'personIdTag' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phoneDisplay' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phoneE164' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useDualChannelDraftRecipientsQuery__
 *
 * To run a query within a React component, call `useDualChannelDraftRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDualChannelDraftRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDualChannelDraftRecipientsQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useDualChannelDraftRecipientsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DualChannelDraftRecipientsQuery, DualChannelDraftRecipientsQueryVariables>) {
  return ApolloReactHooks.useQuery<DualChannelDraftRecipientsQuery, DualChannelDraftRecipientsQueryVariables>(DualChannelDraftRecipientsDocument, baseOptions);
}
export function useDualChannelDraftRecipientsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DualChannelDraftRecipientsQuery, DualChannelDraftRecipientsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<DualChannelDraftRecipientsQuery, DualChannelDraftRecipientsQueryVariables>(DualChannelDraftRecipientsDocument, baseOptions);
}
export type DualChannelDraftRecipientsQueryHookResult = ReturnType<typeof useDualChannelDraftRecipientsQuery>;
export type DualChannelDraftRecipientsLazyQueryHookResult = ReturnType<typeof useDualChannelDraftRecipientsLazyQuery>;
export type DualChannelDraftRecipientsQueryResult = Apollo.QueryResult<DualChannelDraftRecipientsQuery, DualChannelDraftRecipientsQueryVariables>;
